module.exports = __webpack_public_path__ + "static/media/ws.13edfcff.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ws.svg
// module id = 2244
// module chunks = 0